/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal } from '@angular/core';
import { ColumnDatatable } from './models/columnDatatable.model';

@Component({
  template: `<span class="text-sm text-[#525252]"
    >Extenda esse componente!</span
  >`,
})
export class BaseDatatableHeaderComponent {
  colDef = signal<ColumnDatatable<any>>({ field: '', headerName: '' });
  index = signal<number>(0);

  onFilterChange = signal<(value: Record<string, unknown>) => void>(() => {
    throw new Error(`Esse método deve ser sobrescrito no tableComponent`);
  });
}
